import { useCallback } from 'react';

import { OPTIMIZELY_EVENTS } from '../optimizely.consts';

import { useTrackEventWhenReady } from './useTrackEventWhenReady';

type UseTriggerVehicleViewedEvent = (params: { condition?: boolean; overrideUserId?: string }) => void;

export const useTriggerVehicleViewedEvent = (): UseTriggerVehicleViewedEvent => {
	const track = useTrackEventWhenReady(OPTIMIZELY_EVENTS.VEHICLE_VIEWED);

	return useCallback(
		({ condition = true, overrideUserId }) => {
			track({ attributes: { $opt_bucketing_id: null }, condition, overrideUserId });
		},
		[track],
	);
};
